import React  from 'react';
import {MemoryRouter, Switch} from 'react-router';
import {Link, Route} from 'react-router-dom';
import {Row, FlexSpan} from './layoutComponents';
import {MenuBar, MenuIcon, MenuIconSpan, Button} from './styledComponents';
import {UI} from './ui';
import {ProfileContainer} from './containers/profileContainer';
import {ProxiedButton} from './interfaces';
import {SettingsContainer} from './containers/settingsContainer';
import {Info} from './info';
import {Settings} from './settings';

export const ProtectedRoute = ({component:Component, authenticated, ...rest}) => {

  if(authenticated){
    return(
      <Component {...rest} authenticated={authenticated} />
    )
  }else{
    return(
    <SettingsContainer />
    )
  }
}


export const Layout = (props)=>{
  let fields;
  if(props.authenticated){
    fields=<Row middle>
    <Link to="/profile"><MenuIcon><MenuIconSpan className="icon-gear"></MenuIconSpan></MenuIcon></Link>
    <FlexSpan />
    <Link to="/"><MenuIcon><MenuIconSpan className="icon-code" /></MenuIcon></Link>
    <Link to="/info"><MenuIcon><MenuIconSpan className="icon-info" /></MenuIcon></Link>
    <ProxiedButton action={props.signOut} label="Logout" /></Row>
  }else{
    fields=<Row>
    <FlexSpan />
    <Link to="/info"><MenuIcon><MenuIconSpan className="icon-info" /></MenuIcon></Link>
    <Button buttonPadding="12px"><Link to="/">Login</Link></Button>
    </Row>
  }
  return(
    <div>
      <MemoryRouter>
        <div>
        <MenuBar connected={props.online || false} >
          {fields}
          </MenuBar>
          <Switch>
            <Route exact path="/info" component={Info} />
            <ProtectedRoute exact path="/" {...props} component={UI} />
            <ProtectedRoute exact path="/profile" {...props} component={ProfileContainer} />
            <Route path="/settings" {...props} component={SettingsContainer} />
          </Switch>
        </div>
      </MemoryRouter>
    </div>
  )
}



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/layout.js